import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { IconName } from 'src/app/helpers/icon-exports';

export type KpiCardColor = 'green' | 'orange' | 'blue' | 'red' | 'purple' | 'yellow';

const COLOR_MAP: Record<KpiCardColor, { bg: string; icon: string }> = {
  green:  { bg: '#deefd2', icon: '#629d37' },
  orange: { bg: 'rgba(255,172,77,0.23)', icon: '#FFAC4D' },
  blue:   { bg: 'rgba(0,121,184,0.15)', icon: 'rgba(0,121,184,1)' },
  red:    { bg: '#fcc5c5', icon: '#dc2626' },
  purple: { bg: 'rgba(122,92,207,0.25)', icon: '#7a5ccf' },
  yellow: { bg: 'rgba(254,194,14,0.18)', icon: 'rgba(254,194,14,1)' },
};

@Component({
  selector: 'app-kpi-card',
  imports: [CommonModule, SvgIconComponent],
  template: `
    <div class="kpi-card"
         [class.kpi-card--active]="active"
         [class.kpi-card--clickable]="clickable"
         [style.--kpi-active-color]="colors.icon"
         (click)="clickable && cardClick.emit()">
      <div class="kpi-card-top">
        <span class="kpi-label">{{ label }}</span>
        <div class="kpi-icon" [style.background]="colors.bg">
          <app-svg-icon [icon]="icon" [size]="24" [strokeWidth]="1.5" [color]="colors.icon"></app-svg-icon>
        </div>
      </div>
      <div class="kpi-value" [class.kpi-value-sm]="smallValue">
        @if (loading) {
          <div class="kpi-skeleton"></div>
        } @else {
          {{ value ?? '—' }}<span *ngIf="total !== null" class="kpi-sub-value" i18n="@@kpi-card-of"> of {{ total }}</span><span *ngIf="unit" class="kpi-unit"> {{ unit }}</span>
        }
      </div>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./kpi-card.component.css']
})
export class KpiCardComponent {
  @Input() label = '';
  @Input() value: string | number | null = null;
  @Input() unit = '';
  @Input() icon: IconName = 'dashboard-square';
  @Input() color: KpiCardColor = 'green';
  @Input() smallValue = false;
  @Input() total: number | null = null;
  @Input() loading = false;
  @Input() active = false;
  @Input() clickable = false;
  @Output() cardClick = new EventEmitter<void>();

  get colors() {
    return COLOR_MAP[this.color];
  }
}
